import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import defaultStyles from './ResequencingToolbar.module.css';
import jlrStyles from './ResequencingToolbarJlr.module.css';
import AttributesSelector from '../AttributesSelector/AttributesSelector';
import { Button } from '../../atomicComponents';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import { setStylesAccordingToPlant } from '../../utils/utils';

const ResequencingToolbar = ({
  lineName,
  date,
  optionalColumns,
  selectedOptionalColNames,
  handleColumnSelection,
  disableSubmit,
  handleSubmit,
  submitButtonText,
  handleCancel,
  cancelButtonText = 'Cancel',
  pendingCount,
  isDragAndDropEnabled,
}) => {
  const [plant] = usePlantAndLinesStore().plantState;
  const [styles, setStyles] = useState(defaultStyles);
  const isLucknowProlifePlant = plant.label === 'Lucknow-Prolife'
  const parentName = isLucknowProlifePlant ? 'Part No': 'VC'

  useEffect(() => {
    setStylesAccordingToPlant(plant, setStyles, defaultStyles, jlrStyles);
  }, [plant]);

  return (
    <div className={styles.toolbar}>
      <div className={styles.leftToolbar}>
        <p>
          <span style={{ marginRight: '1em' }}>
            <strong>{lineName?.toUpperCase()}</strong>
          </span>
          <span>
            Manual <strong> Resequence</strong>
          </span>
          <span className={styles.currDate}>{date.format('DD-MM-YYYY')}</span>
          {pendingCount != null && (
            <span className={styles.pendingCount}>
              Pending : <strong> {pendingCount}</strong>
            </span>
          )}
        </p>
      </div>
      <div className={styles.rightToolbar}>
        <AttributesSelector
          buttonClassName={styles.attributesSel}
          columns={optionalColumns}
          selectedOptionalCols={selectedOptionalColNames}
          applyColumnsSelection={handleColumnSelection}
        />
        {isDragAndDropEnabled && (
          <div className={styles.dragAndDropNote}>
            Note: Define your preferred order for {parentName}(s) drop by dragging each
            into the desired position before generating ASNs.
          </div>
        )}
        <div>
          <Button
            variant="secondary"
            className={styles.actionButton}
            onClick={handleCancel}
          >
            {cancelButtonText}
          </Button>
          <Button
            variant="primary"
            className={styles.actionButton}
            disabled={disableSubmit}
            onClick={handleSubmit}
          >
            {submitButtonText}
          </Button>
        </div>
      </div>
    </div>
  );
};

ResequencingToolbar.propTypes = {
  lineName: PropTypes.string.isRequired,
  date: PropTypes.objectOf(moment),
  optionalColumns: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      field: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      width: PropTypes.number.isRequired,
      style: PropTypes.object,
    }),
  ),
  selectedOptionalColNames: PropTypes.arrayOf(PropTypes.string),
  handleColumnSelection: PropTypes.func.isRequired,
  disableSubmit: PropTypes.any,
  handleSubmit: PropTypes.func.isRequired,
  submitButtonText: PropTypes.string,
  pendingCount: PropTypes.number,
  isDragAndDropEnabled: PropTypes.bool,
};

export default ResequencingToolbar;
